import { render, staticRenderFns } from "./termList.vue?vue&type=template&id=5cc82314&scoped=true"
import script from "./termList.vue?vue&type=script&lang=js"
export * from "./termList.vue?vue&type=script&lang=js"
import style0 from "./termList.vue?vue&type=style&index=0&id=5cc82314&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc82314",
  null
  
)

export default component.exports